
import { defineComponent, nextTick, ref } from "vue";
import { Form } from "vee-validate";
import { hideModal } from "@/core/helpers/dom";
import { useI18n } from "vue-i18n/index";
export default defineComponent({
  emits: ["status-modal-value", "on-cancel"],
  props: {
    site: { type: Object, default: null },
  },
  components: {
    Form,
  },
  setup(props, { emit }) {
    const { t, te } = useI18n();
    function translate(key: string) {
      if (te(key)) {
        return t(key);
      } else {
        return key.split(".").join(" ");
      }
    }

    const newTargetCloneModalRef = ref<null | HTMLElement>(null);
    const addressData = ref<any>("");
    const cloneSiteRef = ref<null | HTMLFormElement>(null);
    const showAddressModal = ref<boolean>(false);
    const isEditMode = ref<boolean>(true);
    const loading = ref(false);
    const status = ref("ACTIVE");
    const discard = () => {
      hideModal(newTargetCloneModalRef.value);
      nextTick(() => {
        cloneSiteRef?.value?.resetForm();
      });
      emit("on-cancel", null);
    };
    const submitModalData = async () => {
      emit("status-modal-value", status.value);
      discard();
    };

    return {
      translate,
      newTargetCloneModalRef,
      cloneSiteRef,
      discard,
      loading,
      showAddressModal,
      addressData,
      isEditMode,
      submitModalData,
      status,
    };
  },
});
